module.exports = __webpack_public_path__ + "ico-crypto-theta.svg?10898be1127222578099f58973a7a52b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-theta.svg
// module id = 462
// module chunks = 2